import { type ComponentType } from 'react';
import AppSpinner from '~/components/Loading/AppSpinner';

interface LoadingOverlayProps {
  Spinner?: ComponentType;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ Spinner }) => (
  <div className="absolute inset-0 bg-gray-200/20 backdrop-blur-[1px] z-10 flex items-center justify-center">
    {Spinner ? <Spinner /> : <AppSpinner />}
  </div>
);

export default LoadingOverlay;
